/* SpawnAnything — dice: two random armies, guess the winner, then watch (user decision 02.10.2026: "würfeln + tippen").
   Both sides get about the same points (measured campaign prices, src/features/campaignCosts.js), so the guess is a real
   question and knowing the counters (splash vs. crowds, ranged vs. melee) pays off. No coins, no diamonds: only a streak. */
import './dice.css';
import { rollArmies } from './diceRoll.js';

const STREAK_KEY = 'aw-dice';

function readStreak() { try { const v = JSON.parse(localStorage.getItem(STREAK_KEY) || '{}'); return { cur: v.cur | 0, best: v.best | 0 }; } catch { return { cur: 0, best: 0 }; } }
function writeStreak(s) { try { localStorage.setItem(STREAK_KEY, JSON.stringify(s)); } catch { /* private mode */ } }

/**
 * @param {{ types: object, cost: (type: string) => number, allowType: (k: string) => boolean,
 *   apply: (a: Array, b: Array) => void, start: () => void, toast: (m: string) => void, blocked: () => string,
 *   rng?: () => number }} o   apply gets writeCfg rows [type, count, weapon, size]
 */
export function createDice(o) {
  const rng = o.rng || Math.random;
  let tip = -1, rolled = null;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  const card = document.createElement('section');
  card.className = 'dice-card'; card.hidden = true; card.setAttribute('role', 'dialog'); card.setAttribute('aria-label', 'Würfeln und tippen');
  document.body.appendChild(card);

  const roll = () => rollArmies(o.types, o.cost, o.allowType, rng);
  const label = r => `${r[1].toLocaleString('de-DE')} ${r[1] === 1 ? o.types[r[0]].name : o.types[r[0]].plural || o.types[r[0]].name}`;

  function render() {
    const s = readStreak();
    card.innerHTML = `<div class="dice-h"><i class="ti ti-dice-5" aria-hidden="true"></i> Wer gewinnt?</div>
      <div class="dice-vs"><b class="t0">${esc(label(rolled[0]))}</b><span>gegen</span><b class="t1">${esc(label(rolled[1]))}</b></div>
      <div class="dice-pick"><button class="tb0" data-tip="0">Blau gewinnt</button><button class="tb1" data-tip="1">Rot gewinnt</button></div>
      <div class="dice-foot"><button class="ghost" data-a="again"><i class="ti ti-refresh" aria-hidden="true"></i> Neu würfeln</button>
        <span>${s.cur ? `Serie: ${s.cur}` : ''}${s.best ? ` · Bestwert ${s.best}` : ''}</span><button class="ghost" data-a="close">Abbrechen</button></div>`;
  }
  card.addEventListener('click', e => {
    const t = e.target.closest('[data-tip]'), a = e.target.closest('[data-a]');
    if (t) { tip = +t.dataset.tip; card.hidden = true; o.start(); }
    else if (a && a.dataset.a === 'again') open();
    else if (a && a.dataset.a === 'close') { card.hidden = true; tip = -1; }
  });

  /** Roll, set up both armies and ask for the guess. */
  function open() {
    const why = o.blocked(); if (why) { o.toast(why); return; }
    rolled = roll(); if (!rolled) { o.toast('Zu wenige Einheiten freigeschaltet zum Würfeln.'); return; }
    tip = -1;
    o.apply(rolled[0], rolled[1]);
    render(); card.hidden = false;
    card.querySelector('[data-tip]')?.focus();
  }

  /** Battle over (winner 0 / 1 / -1): line for the victory banner, or '' when no guess was running. */
  function finish(winner) {
    if (tip < 0) return '';
    const s = readStreak(), ok = winner === tip;
    s.cur = ok ? s.cur + 1 : 0; s.best = Math.max(s.best, s.cur); writeStreak(s);
    tip = -1;
    return ok ? `Dein Tipp war richtig! Serie: ${s.cur}${s.cur === s.best && s.cur > 1 ? ' (Bestwert)' : ''}` : 'Dein Tipp lag daneben. Die Serie beginnt neu.';
  }

  return { open, finish, roll, cancel: () => { tip = -1; card.hidden = true; }, get tip() { return tip; } };
}
